<template>
  <div>
    <div>
      <div class="modal" :class="{ 'is-active': createReportPop }">
        <div @click="allModalClose"></div>
        <div class="modal-content">
          <div class="box modal-container">
            <div class="modal-content-root" style="overflow: visible;">
              <div class="select-a-setup-type">AI Writer report</div>
              <div class="setup-type-explain mt-4">
                Type your target keyword and select your target language and
                region
              </div>

              <div class="mt-4 m-auto">
                <div
                  class="mb5 wow_disaled slideInLeft"
                  data-wow-delay="0.3s"
                >
                  <b>Target keyword</b>
                </div>
                <div class="control">
                  <input
                    type="text"
                    class="input site-url-input"
                    id="keyword"
                    ref="keyword"
                    v-model="keyword"
                    placeholder="Type your target keyword"
                  />
                </div>
                <div class="has-text-danger mt-2">
                  {{ aiErrors?.keywordError }}
                </div>
              </div>

              <div class="d-flex align-center gap10 mb-6">
                <div style="flex: 1;">
                  <div class="mb5 mt-5">
                    <b>Language</b>
                  </div>
                  <div class="control">
                    <v-autocomplete
                      :items="targetLanguages"
                      v-model="thisTargetLang"
                      placeholder="Choose language"
                      @change="handleChangeLanguage"
                      property
                      outlined
                      dense
                    ></v-autocomplete>
                  </div>
                  <div
                    class="has-text-danger"
                    :style="{ marginTop: '-15px' }"
                  >
                    {{ aiErrors?.languageError }}
                  </div>
                </div>

                <div style="flex: 1;">
                  <div class="mb5 mt-5">
                    <b>Region</b>
                  </div>
                  <div class="control">
                    <v-autocomplete
                      :items="googleSearchLocations"
                      placeholder="Choose region"
                      v-model="searchLocation"
                      @change="handleLocationSelected"
                      item-text="name"
                      property
                      item-value="id"
                      outlined
                      dense
                    ></v-autocomplete>
                  </div>
                  <div
                    class="has-text-danger"
                    :style="{ marginTop: '-13px' }"
                  >
                    {{ aiErrors?.regionError }}
                  </div>
                </div>
              </div>
              <div class="continue-button-area">
                <v-btn
                  rounded
                  color=""
                  class="button-with-icon back-button-text mr-2 mainColor--text text-none"
                  @click="dismissPickingReportTypeModalAndGoBack"
                >
                  <span>Back</span>
                </v-btn>
                <v-btn
                  rounded
                  color="profileAnchorColor"
                  class="button-with-icon continue-button-text whiteColor--text text-none"
                  @click="submitForm"
                >
                  <span>Continue</span>
                  <i class="material-icons">arrow_forward</i>
                </v-btn>
              </div>
            </div>
          </div>
          <button
            class="custom-modal-close-btn"
            aria-label="close"
            @click="allModalClose"
          >
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isInSameDomain, getPathNameFromUrl } from "@/utils";

export default {
  props: ["targetLanguages", "createReportPop"],
  data() {
    return {
      thisTargetLang: this.targetLang,
      searchLocation: "",
      selectedRegion: "",
      keyword: "",
      selectedLanguage: "",
      aiErrors: {
        keywordError: "",
        regionError: "",
        languageError: "",
      },
    };
  },
  computed: {
    site () {
      return this.$store.getters.siteById(parseInt(this.$route.params.siteId)) || {}
    },
    baseUrl () {
      return this.site.baseURL
    },
    cleanBaseUrl() {
      let rlt = this.baseUrl.replace(/\/$/, '')
      return rlt
    },
    googleSearchLocations() {
      if (this.$store.getters.getGoogleLocations) {
        return this.$store.getters.getGoogleLocations.filter(item => !item.includes('Extension'))
      }
      return [];
    },
  },
  methods: {
    submitForm() {
      if (!this.selectedLanguage) {
        this.aiErrors.languageError = "Please choose a language";
      }
      if (!this.selectedRegion) {
        this.aiErrors.regionError = "Please choose a region";
      }
      if (!this.keyword) {
        this.aiErrors.keywordError = "Please enter keyword";
      }
      if (Object.values(this.aiErrors).some(Boolean)) {
        return;
      }

      this.$store.commit("showLoading");
      this.addNewPage();
    },
    addNewPage() {
      this.$store.commit("setAiWritingData", {
        lang: this.selectedLanguage,
        region: this.selectedRegion,
        keyword: this.keyword,
        url: `${this.cleanBaseUrl}`,
      });
      this.$store.commit("hideLoading");
      this.$router.push(
        `/ai-writer-waiting/${this.site.id}`
      );
      this.$emit("close-modal")
      this.$emit("mainModalCLose")
    },
    dismissPickingReportTypeModalAndGoBack() {
      this.$emit("close-modal");
    },
    allModalClose() {
      this.$emit("mainModalCLose");
    },
    handleChangeLanguage(option) {
      this.selectedLanguage = option;
    },
    handleLocationSelected(option) {
      this.selectedRegion = option;
    },
  },
  watch: {
    createReportPop(newValue, oldValue) {
      if (newValue === false && oldValue === true) {
        this.selectedLanguage = "";
        this.selectedRegion = "";
        this.searchLocation = "";
        this.keyword = "";
        this.selectedLanguage = null;
        this.selectedRegion = null;
        this.keyword = null;
      }
    },
    selectedLanguage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.aiErrors.languageError = "";
      }
    },
    selectedRegion(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.aiErrors.regionError = "";
      }
    },
    keyword(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.aiErrors.keywordError = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  color: var(--v-mainColor-base);
}

.modal-content {
  width: 30vw;
}

ul {
  margin-left: 0;
}

.tag {
  margin: 3px;
}

.back-button-text {
  border: 1px solid var(--v-mainColor-base);
  height: 38px !important;
  background: none !important;

  span {
    font-size: 17px !important;
    font-weight: 700 !important;
  }
}

.continue-button-text {
  height: 38px !important;

  i,
  span {
    font-size: 17px !important;
    font-weight: 700 !important;
  }

  i {
    margin-top: 2px;
  }
}

.site-url-input {
  color: var(--v-primary-base);
}

@media screen and (min-width: 769px) {
  .modal-content,
  .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 700px;
  }
}

.select-a-setup-type {
  font-size: 22px;
  font-weight: 800;
  text-align: left;
}

.setup-type-explain {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}

.setup-type-boxes {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  & > div {
    flex: 1 1 270px;
    border: 2px solid var(--v-grayColor-base);
    border-radius: 5px;
    padding: 20px 50px;
    cursor: pointer;

    &.active {
      border-color: var(--v-profileAnchorColor-base);
    }

    i.material-icons {
      color: var(--v-profileAnchorColor-base);
      font-size: 2rem;
    }

    .setup-type-name {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 800;
    }

    .type-explain {
      margin-top: 5px;
      font-size: 1rem;

      ul {
        padding-left: 0;
        margin-top: 10px;
        list-style: inside;
      }
    }
  }
}

.continue-button-area {
  margin-top: 10px;
  text-align: right;
}
</style>
